import { render, staticRenderFns } from "./Error504Module.vue?vue&type=template&id=691746e4&scoped=true"
import script from "./Error504Module.vue?vue&type=script&lang=js"
export * from "./Error504Module.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691746e4",
  null
  
)

export default component.exports